import { render, staticRenderFns } from "./Raport_devize_penalizate.vue?vue&type=template&id=3d6720b3&scoped=true"
import script from "./Raport_devize_penalizate.vue?vue&type=script&lang=js"
export * from "./Raport_devize_penalizate.vue?vue&type=script&lang=js"
import style0 from "./Raport_devize_penalizate.vue?vue&type=style&index=0&id=3d6720b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6720b3",
  null
  
)

export default component.exports